import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=79393a46&scoped=true"
import script from "./Partner.vue?vue&type=script&lang=js"
export * from "./Partner.vue?vue&type=script&lang=js"
import style0 from "./Partner.vue?vue&type=style&index=0&id=79393a46&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79393a46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79393a46')) {
      api.createRecord('79393a46', component.options)
    } else {
      api.reload('79393a46', component.options)
    }
    module.hot.accept("./Partner.vue?vue&type=template&id=79393a46&scoped=true", function () {
      api.rerender('79393a46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homepage/components/Partner.vue"
export default component.exports